import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import Text from '../../common/component/CustomTextComponent';
import { THEME_COLORS } from '../../common/themes';

interface ICustomButtonInterface{
    onPress?:()=>void;
    disabled?:boolean;
    processing?:boolean;
    backgroundColor?:string;
    textColor?:string;
    text:string;
    height?:string | number;
    style?:any;
    width?:string | number;
}

const CustomButtonTwo=(props:ICustomButtonInterface)=>{
    const { text, onPress, backgroundColor, disabled, textColor, style, height, width, processing } = props;

    const passedStyles = style && Array.isArray(style) ? style : [style];

    const disableOrProcessing = disabled || processing;

    return (
        <TouchableOpacity disabled={disableOrProcessing} style={[styles.container,...passedStyles,
            {backgroundColor:backgroundColor ?? THEME_COLORS.grey1,height:height ?? 40,
            width:width ?? "100%", opacity:disableOrProcessing ? 0.4 : 1, shadowRadius: 5, shadowOpacity: 0.5}, {
                transition: 'box-shadow 0.3s ease-in-out',
                userSelect: 'none'
            }]} onPress={onPress}>
            {processing ? <Text type_of_six={"three_six"} style={{color:textColor ?? THEME_COLORS.grey0}}>Loading...</Text> : <Text type_of_six={"three_six"} style={{color:textColor ?? THEME_COLORS.grey0}}>{text ?? ""}</Text>}
        </TouchableOpacity>
    )
}

const styles = StyleSheet.create({
    container:{
        borderRadius:8,
        justifyContent:"center",
        alignItems:"center",
        margin:5
    }
});

export default CustomButtonTwo;
